import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DevActivityTracker"] */ "/vercel/path0/src/components/admin/dev-activity-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/src/components/analytics/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthGate"] */ "/vercel/path0/src/components/auth-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CrateDrawerHost"] */ "/vercel/path0/src/components/crates/crate-drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBar"] */ "/vercel/path0/src/components/impersonation-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/src/components/layout/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/vercel/path0/src/components/legal/cookie-consent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistrar"] */ "/vercel/path0/src/components/pwa/sw-registrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/contexts/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandingProvider"] */ "/vercel/path0/src/contexts/branding-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelpProvider"] */ "/vercel/path0/src/contexts/help-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediaPlayerProvider"] */ "/vercel/path0/src/contexts/media-player-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TapInfoProvider"] */ "/vercel/path0/src/contexts/tap-info-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/contexts/theme-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserLayoutPrefsProvider"] */ "/vercel/path0/src/contexts/user-layout-prefs-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisibilityProvider"] */ "/vercel/path0/src/contexts/visibility-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalletProvider"] */ "/vercel/path0/src/contexts/wallet-context.tsx");
